import * as Sentry from "@sentry/vue";

const SENTRY_DSN = 'https://656834ec6dd8562d802d9afaa9cefac7@o4503936362872832.ingest.us.sentry.io/4511739464450048';

// environnement de l'app enregistré dans ton .env
window.env = import.meta.env.VITE_ENV

export let useSentry = (app : any, router : any) => {
    if (window.env != 'local') {
        Sentry.init({
            app,
            dsn: SENTRY_DSN,
            integrations: [
                Sentry.browserTracingIntegration({ router }),
                // vidéos replay
                Sentry.replayIntegration()
            ],  
            // si env local, preprod, prod...
            environment: window.env,
            // nom de la realse pour track quel version de l'app à générer l'erreur
            release: "Hippodrome_1.0",
            // % de track des erreurs
            tracesSampleRate: 1.0, 
            // url autorisées au tracking
            tracePropagationTargets: ["localhost", /^https:\/\/api\.hp\.prep\.digiworks\.fr/, /^https:\/\/hp\.prep\.digiworks\.fr/, /^https:\/\/api\.hippodrome-manager\.com/, /^https:\/\/general\.hippodrome-manager\.com/],
            // % de capture vidéo sans erreur (juste comment l'user intéragit avec l'app)
            replaysSessionSampleRate: 0,
            // % de capture vidéo lors des erreurs
            replaysOnErrorSampleRate: 0.25,
        });
    };
}